module.exports = __webpack_public_path__ + "img/1557614056671617025.3b7c2819.png";